import { render, staticRenderFns } from "./TagManagementView.vue?vue&type=template&id=5a39dd14&scoped=true"
import script from "./TagManagementView.vue?vue&type=script&lang=js"
export * from "./TagManagementView.vue?vue&type=script&lang=js"
import style0 from "./TagManagementView.vue?vue&type=style&index=0&id=5a39dd14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a39dd14",
  null
  
)

export default component.exports